import React from "react";
import { usePage } from "@inertiajs/inertia-react";

/**
 * Heading component that displays page titles with optional product information
 * Provides consistent header styling across the application
 *
 * @param {Object} props - Component props
 * @param {string} props.heading - Main heading text to display
 * @param {string} props.subheading - Optional subheading text
 * @param {ReactNode} props.children - Optional child elements (typically action buttons)
 * @param {boolean} props.hideProduct - Whether to hide product name display (default: false)
 */
const Heading = ({ heading, subheading, children, hideProduct = false }) => {
    // Get product data from Inertia page props
    const { product } = usePage().props;

    return (
        <div className={"headingspace d-flex justify-content-between"}>
            <div className={"align-self-center"}>
                {!hideProduct && product && <p>{product.product_name}</p>}
                <p className="boldheading mb-0">{heading}</p>
                {subheading ? (
                    <p className="subheading mt-1">{subheading}</p>
                ) : (
                    <></>
                )}
            </div>
            {children}
        </div>
    );
};

export default Heading;
